import { createFileRoute, redirect } from "@tanstack/react-router";

import { getAccessToken } from "../auth";

export const Route = createFileRoute("/")({
  beforeLoad: () => {
    if (getAccessToken()) throw redirect({ to: "/app/overview" });
    throw redirect({ to: "/login", search: { activated: false } });
  },
});
